import styled from 'styled-components';
import AutoForm from 'react-auto-form';

import FlexBox from '../../FlexBox';

import zIndex from '../../../utils/zIndexScale';


const Title = styled.h2`
  color: #333;
  font-size: 16px;
  font-weight: bold;
  padding: 15px 20px;
  border-bottom: 1px solid #f0f0f0;
  text-transform: uppercase;
`;

const StyledBox = styled(FlexBox)`
  background-color: #fff;
  width: 960px;
  min-height: 840px;
  margin: 0 auto;
  margin-top: 20px;
  border: 1px solid #f0f0f0;
`;

const Container = styled(FlexBox)`
  padding: 2em 4em;
`;

const EmptyContainer = styled(FlexBox)`
  background-color: #f7f7f7;
  flex: 1 0 300px;
  margin-bottom: 3em;
`;

const EmptyImageContainer = styled(FlexBox)`
  background-color: #fff;
  border: 1px solid #f0f0f0;
  flex-basis: 150px;
  min-width: 260px;
  margin-bottom: 2em;
`;

const EmptyImage = styled.img.attrs(({
  src: require('./icon-mobile.png'),
}))`
  max-width: 100%;
`;

const EmptyImageInnerContainer = styled(FlexBox)`
  background-color: #f7f7f7;
  border-radius: 50%;
  flex-basis: 100px;
  min-height: 100px;
`;

const EmptyHeader = styled.h3`
  /* bad */
  color: #f0b90b !important;
  font-size: 1.6em;
  font-weight: bold;
  margin-bottom: .3em;
`;

const EmptyMessage = styled.p`
  font-size: 1.2em;
`;

const DetailContainer = styled(FlexBox)`
  margin-bottom: 3em;
`;

const Detail = styled(FlexBox)`
  font-size: 1.1em;
  flex-basis: 33.3%;
  padding: .1em;
  word-break: break-all;
`;

const Warning = styled.p`
  color: #f15866;
  margin-top: .5em;
`;

const CTA = styled.button`
  border: none;
  border-radius: 2px;
  color: #fff;
  cursor: pointer;
  padding: .5em 1.5em .5em 2em;
  width: fit-content;
  min-width: 120px;

  &:hover {
    opacity: ${({ active }) => active ? '.8' : '1'};
  }
`;

const DetailCTA = styled(CTA)`
  background-color: ${({ active }) => active ? '#f0b90b' : '#d4d4d4'};
  transition: background-color .3s linear;
  position: relative;

  .iconfont {
    position: absolute;
    left: 7px;
  }
`;

const SubmitCTA = styled(CTA)`
  background-color: ${({ active }) => active ? '#f0b90b' : '#d4d4d4'};
  transition: background-color .3s linear;
  flex-basis: 70%;
  margin-top: 2em;
`;

const FormContainer = styled(FlexBox)`
  border-top: 1px solid #f8dc84;
  padding: 3em 0;
  position: relative;
  margin-top: 2em;

  &:after,
  &:before {
    height: 20px;
    width: 20px;
    top: -10px;
    left: 10%;
    content: '';
    position: absolute;
    transform: rotate(45deg);
  }

  &:after {
    background-color: #f8dc84;
  }

  &:before {
    background-color: #fff;
    top: -12px;
    z-index: ${zIndex.hint};
  }
`;

const DetailProviderLabel = styled(FlexBox)`
  background-color: ${({ labelColor }) => labelColor || '#fff'};
  border-radius: 2px;
  color: #fff;
  padding: .1em .3em;
  font-size: .8em;
`;

const DetailEntryForm = styled(AutoForm)`
  display: flex;
  flex: 1 0 100%;
  flex-direction: column;
  max-width: 60%;
`;

const FormLabel = styled.label`
  display: flex;
  flex: 1 1 100%;
  margin: 1em 0;
  position: relative;
`;

const LabelText = styled.span`
  align-items: center;
  color: #666;
  display: flex;
  font-size: 1.1em;
  flex: 1 0 125px;
`;

const FormInput = styled.input`
  display: flex;
  flex: 1 0 ${({ alt }) => alt ? '34%' : '60%'};
  font-size: 1.2em;
  border: ${({ disabled, error }) => {
    if (disabled) return 'none';
    if (error) return '1px solid #ef4b5a';
    return '1px solid #d4d4d4';
  }};
  border-radius: 2px;
  margin-right: ${({ alt }) => alt ? '1em' : '0'};
  padding: .05em .5em 0;
  ${({ countryCode }) => countryCode ? 'padding-left: 3em;' : ''}
`;

const FormSelect = styled.select`
  appearance: none;
  background-color: #fff;
  background-image: url(${require('./icon-select-menu.png')});
  background-repeat: no-repeat;
  background-position: 98%;
  color: ${({ provider }) => provider === '' ? '#a3a3a3' : '#555'};
  display: flex;
  flex: 1 0 60%;
  font-size: 1.2em;
  border: 1px solid #d4d4d4;
  border-radius: 2px;
  padding: 0 .5em;
  &:disabled {
    color: #a3a3a3;
  }
`;

const FormError = styled.span`
  color: #ef4b5a;
  left: 32%;
  bottom: -20px;
  position: absolute;
`;

export default {
  Title,
  StyledBox,
  Container,
  EmptyContainer,
  EmptyImageContainer,
  EmptyImage,
  EmptyImageInnerContainer,
  EmptyHeader,
  EmptyMessage,
  DetailContainer,
  Detail,
  Warning,
  DetailCTA,
  SubmitCTA,
  FormContainer,
  DetailProviderLabel,
  DetailEntryForm,
  FormLabel,
  LabelText,
  FormInput,
  FormSelect,
  FormError,
};
